import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../../components';
import { Button, Stack, Typography } from '@mui/material';
import { OCCUPY_STATUS, YES_NO } from '../../../../../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';

export const RoomMasterBedForm = ({ onAdd, onClose }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        bed_no: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      occupy_status: "F",
      cradle_charge: 'No',
      status: 'active'
    },
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const bedNoRef = useRef();


  const formSubmit = (formValue) => {
    onAdd(formValue);
    reset();
    if (bedNoRef.current) {
      bedNoRef.current.focus();
    }
  };

  useEffect(() => {
    if (bedNoRef.current) {
      bedNoRef.current.focus();
    }
  }, []);


  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
        <Typography sx={{ flex: 0.4 }}>Bed No.</Typography>
        <TextField sx={{ flex: 0.6 }} name="bed_no" placeholder="Bed No." inputRef={bedNoRef} />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
        <Typography sx={{ flex: 0.4 }}>Occupy Status</Typography>
        <SelectTag
          formControlSX={{ flex: 0.6 }}
          name="occupy_status"
          menus={OCCUPY_STATUS}
          placeholder="Occupy Status"
        />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
        <Typography sx={{ flex: 0.4 }}>Cradle Charge</Typography>
        <SelectTag formControlSX={{ flex: 0.6 }} name="cradle_charge" menus={YES_NO} />
      </Stack>
      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
        <Typography sx={{ flex: 0.4 }}>Status</Typography>
        <SelectTag
          formControlSX={{ flex: 0.6 }}
          name="status"
          menus={[
            { _id: 'active', name: 'Active' },
            { _id: 'inactive', name: 'Inactive' }
          ]}
        />
      </Stack>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
